import React from 'react';
import { useSelector } from 'react-redux';

import { getMeetingItemByUuid } from 'Shared/selectors/common';
import DraftEditor from 'Shared/components/DraftEditor/DraftEditor';
import { editorStateForEditorComponent } from 'Shared/utils/draftJsHelpers';

import './ItemDragLayer.scss';

type Props = {
  offsetTop: number;
  offsetLeft?: number;
  itemUuid?: string;
  body?: string;
};

export function MobilePreviewDragLayer({ offsetTop, offsetLeft = 0, itemUuid, body }: Props) {
  const itemBody = useSelector(state => body || getMeetingItemByUuid(itemUuid)(state)?.body);

  const editorState = editorStateForEditorComponent(itemBody);

  return (
    <div className="drag-layer-container" style={{ top: offsetTop, left: offsetLeft }}>
      <div className="drag-layer-item">
        <DraftEditor readOnly editorState={editorState} onChange={() => null} />
      </div>
    </div>
  );
}
